import { Input } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { StaffStateData } from './StaffPage';
import { CheckCircleOutlined } from '@ant-design/icons';

interface Props {
    staffData: StaffStateData;
    onInputChange: (soid: string, upi_id: string) => void;
    onUPIDetailsHandler: (staffData: StaffStateData) => void;
    isVerifyingBankDetails?: boolean;
    cur_soid?: string;
}

class StaffUPIIDDetails extends PureComponent<Props> {
    render(): ReactNode {
        const {
            staffData,
            onInputChange,
            onUPIDetailsHandler,
            isVerifyingBankDetails,
            cur_soid,
        } = this.props;
        const { soid, fund_acc_id } = staffData;
        const disabled = isVerifyingBankDetails || !staffData.upi_id;
        return (
            <div className="relative flex space-x-12">
                <Input
                    defaultValue={staffData?.upi_id}
                    onChange={(e) => onInputChange(soid, e.target.value)}
                    placeholder={`${staffData.fln}'s upi id`}
                    disabled={Boolean(fund_acc_id)}
                />

                {fund_acc_id ? (
                    <div className="flex items-center absolute top-0 right-12 bottom-0">
                        <CheckCircleOutlined
                            style={{ color: 'green', fontSize: '20px' }}
                            onPointerLeaveCapture={undefined}
                        />
                    </div>
                ) : (
                    <button
                        className={`flex items-center space-x-12 bg-darwin-accent-bright-blue-800 text-white rounded-6 px-16 font-700 ${
                            disabled ? 'opacity-70' : ''
                        }`}
                        onClick={() => onUPIDetailsHandler(staffData)}
                        disabled={disabled}
                    >
                        {isVerifyingBankDetails && soid === cur_soid && (
                            <svg
                                className="w-14 h-14 fill-white animate-spin"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                            </svg>
                        )}
                        <p>Validate</p>
                    </button>
                )}
            </div>
        );
    }
}

export default connect()(StaffUPIIDDetails);
